import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/Dashboard";
import LoginPage from "./templates/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./templates/Dashboard";
import Products from "./templates/Products";
import Settings from "./templates/Settings";
import HistoryTemplate from "./templates/History";
import BulkUpdatePage from "./templates/BulkUpdate";
import PageNotFound from "./templates/PageNotFound";
import Description from "./templates/Description";
import CreateBulkOrder from "./templates/BulkUpdate/CreateBulkOrder";
import OrderById from "./templates/BulkUpdate/OrderById";

const AppRoutes = () => {
	const routes = useRoutes([
		{ path: "/login", element: <LoginPage /> },

		{
			path: "/",
			element: (
				<ProtectedRoute>
					<DashboardLayout />
				</ProtectedRoute>
			),
			children: [
				{ index: true, element: <Dashboard /> }, // Correct default route
				{ path: "products", element: <Products /> }, // Removed leading slash
				{ path: "products/generate-description/:id", element: <Description /> }, // Removed leading slash
				{ path: "settings", element: <Settings /> },
				{ path: "history", element: <HistoryTemplate /> },
				{ path: "bulk-AI-generation", element: <BulkUpdatePage /> },
				{ path: "bulk-AI-generation/create-order", element: <CreateBulkOrder /> },
				{ path: "bulk-AI-generation/order/:id", element: <OrderById /> },
			],
		},
		{
			path: "*",
			element: <PageNotFound />,
		},
	]);

	return routes;
};

export default AppRoutes;
